import { Injectable, signal, inject } from '@angular/core';
import { SharedCommonService } from './shared-common.service';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private readonly sharedCommonService = inject(SharedCommonService);
  
  public isLoading = signal(false);
  public loadingMessage = signal<string>('');
  private customLoaderRef: any = null;
  
  constructor() {}

  /**
   * Shows the loader with an optional custom message
   * @param message - Optional custom message to display
   */
  show(message?: string): void {
    this.isLoading.set(true);
    this.loadingMessage.set(message || '');
    
    // Only show custom loader if message is provided, otherwise let interceptor handle it
    if (message) {
      // Hide any existing interceptor loader first
      this.sharedCommonService.hideLoader();
      // Show custom loader with message
      this.sharedCommonService.showLoader(message);
      this.customLoaderRef = true;
    }
  }

  /**
   * Hides the loader and clears the message
   */
  hide(): void {
    this.isLoading.set(false);
    this.loadingMessage.set('');
    
    // Only hide if we showed a custom loader
    if (this.customLoaderRef) {
      this.sharedCommonService.hideLoader();
      this.customLoaderRef = null;
    }
  }

  /**
   * Gets the current loading state
   * @returns Boolean indicating if loading is active
   */
  getLoadingState(): boolean {
    return this.isLoading();
  }

  /**
   * Gets the current loading message
   * @returns Current loading message
   */
  getLoadingMessage(): string {
    return this.loadingMessage();
  }

  /**
   * Checks if a custom loader with message is active
   * @returns Boolean indicating if custom loader is active
   */
  isCustomLoaderActive(): boolean {
    return this.customLoaderRef !== null;
  }
}
